import logo from "../img/logo.png";
import { buildHomeAnchorLink } from "../utils/routes";
import { FaEnvelope, FaFacebookF, FaInstagram, FaPhoneAlt, FaYoutube } from "react-icons/fa";

const Header = ({ standalone = false }) => {
  const resolveHref = (anchor) => {
    if (standalone) {
      return buildHomeAnchorLink(anchor);
    }
    return `#${anchor}`;
  };

  return (
    <header className="header-container">
      <div className="header-contact-bar">
        <div className="header-contact-list">
          <a className="header-contact-item" href="mailto:agrikguatemala@gmail.com">
            <FaEnvelope aria-hidden="true" />
            <span>agrikguatemala@gmail.com</span>
          </a>
          <a className="header-contact-item" href="tel:+50257483808">
            <FaPhoneAlt aria-hidden="true" />
            <span>+502 5748-3808</span>
          </a>
          <a className="header-contact-item" href="tel:+50250423699">
            <FaPhoneAlt aria-hidden="true" />
            <span>+502 5042-3699</span>
          </a>
        </div>
        <div className="header-social-links" aria-label="Redes sociales de Agrik">
          <a
            href="https://www.facebook.com/AgrikGT/?locale=es_LA"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook de Agrik"
          >
            <FaFacebookF aria-hidden="true" />
          </a>
          <a
            href="https://www.instagram.com/agrikgt/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram de Agrik"
          >
            <FaInstagram aria-hidden="true" />
          </a>
          <a
            href="https://www.youtube.com/channel/UC4eO4D0dzbblO46zFAAcPVw"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="YouTube de Agrik"
          >
            <FaYoutube aria-hidden="true" />
          </a>
        </div>
      </div>
      <nav className="navbar navbar-expand-lg header-top">
        <div className="container-fluid">
          <a className="navbar-brand" href={resolveHref("Inicio")}>
            <img className="img-logo" src={logo} alt="logo agrik" width="300" height="100" />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarTogglerHeader"
            aria-controls="navbarTogglerHeader"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse navbar-collapse-header" id="navbarTogglerHeader">
            <div className="d-flex">
              <ul className="navbar-nav mx-auto mb-2 mb-lg-0 nav-underline ">
                <li className="nav-item">
                  <a className="nav-link a-header" aria-current="page" href={resolveHref("Inicio")}>
                    Inicio
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link a-header" href={resolveHref("Productos")}>
                    Productos
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link a-header" href={resolveHref("Nosotros")}>
                    Acerca de Agrik
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link a-header a-header-contactanos" href={resolveHref("Contactanos")}>
                    Contáctanos
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
